<template>
  <div class="page-container">
    <div class="page-header">
      <div class="first-tabs">
        <van-tabs
          v-model="currentTabIndex.first"
          color="#6E4135"
          line-height="4"
          title-active-color="#6E4135"
          title-inactive-color="#2B2B2C"
        >
          <van-tab v-for="item in tabs" :key="item.id" :title="item.title" />
        </van-tabs>
      </div>
      <ul v-if="currentTabChildList.length" class="second-tabs">
        <li
          v-for="(childItem, childIndex) in currentTabChildList"
          :key="childItem.id"
          :class="{ active: childIndex === currentTabIndex.second }"
          @click="changeChildTab(childIndex)"
        >
          {{ childItem.title }}
        </li>
      </ul>
    </div>

    <div class="page-body">
      <div :key="`${currentTabIndex.first}-${currentTabIndex.second}`" class="page-body-content">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getList"
        >
          <template v-if="isGroup">
            <van-collapse v-model="groupActives" :border="false">
              <van-collapse-item
                v-for="groupItem in groupList"
                :key="groupItem.year"
                :title="`${groupItem.year}年`"
                :name="groupItem.year"
              >
                <div class="list">
                  <div
                    class="list-item"
                    v-for="item in groupItem.list"
                    :key="item.id"
                    @click="toDetail(item)"
                  >
                    <van-image
                      width="100%"
                      height="100%"
                      radius="6"
                      :src="item.coverImage"
                      fit="cover"
                    />
                    <span class="van-ellipsis">{{ item.title }}</span>
                  </div>
                </div>
              </van-collapse-item>
            </van-collapse>
          </template>
          <template v-else>
            <div class="list">
              <div
                class="list-item"
                v-for="item in list"
                :key="item.id"
                @click="toDetail(item)"
              >
                <van-image
                  width="100%"
                  height="100%"
                  radius="6"
                  :src="item.coverImage"
                  fit="cover"
                />
                <span class="van-ellipsis">{{ item.title }}</span>
              </div>
            </div>
          </template>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { getListByType, wxInfo } from '@/api/exhibit'
const wxList = [
  {
    id: 'bcbh',
    title: '北朝壁画专题数字展',
    coverImage: require('@/assets/bcbhCover.png'),
    isWx: true
  },
  {
    id: 'jh',
    title: '大河上下 • 晋魂',
    coverImage: require('@/assets/dhsxjh.png'),
    isWx: true
  }
]
export default {
  name: 'ExhibitIndex',
  data: () => ({
    tabs: [
      {
        id: 3,
        title: '数字展'
      },
      {
        id: 1,
        title: '全景导览',
        childList: [
          {
            id: 1,
            title: '晋魂'
          },
          {
            id: 2,
            title: '吉金光华'
          },
          {
            id: 3,
            title: '临时展览'
          }
        ]
      },
      {
        id: 2,
        title: '电子书'
      }
    ],
    // 当前选中tab的下标
    currentTabIndex: {
      // 第一级下标
      first: 0,
      // 第二级下标
      second: 0
    },
    list: [],
    pageNo: 1,
    loading: false,
    finished: false,
    groupActives: []
  }),
  computed: {
    currentTab () {
      return this.tabs[this.currentTabIndex.first]
    },
    currentTabChildList () {
      return this.currentTab.childList || []
    },
    currentChildTab () {
      return this.currentTabChildList?.[this.currentTabIndex.second] || {}
    },
    isGroup () {
      const { first, second } = this.currentTabIndex
      return first === 1 && second === 2
    },
    groupList () {
      if (!this.isGroup) {
        return []
      }

      const data = []
      this.list.forEach((item) => {
        const i = data.findIndex((v) => v.year === item.year)
        if (i === -1) {
          data.push({
            year: item.year,
            list: [item]
          })
        } else {
          data[i].list.push(item)
        }
      })
      return data
    }
  },
  watch: {
    currentTabIndex: {
      handler () {
        this.refresh()
      },
      deep: true
    }
  },
  methods: {
    changeChildTab (index) {
      this.currentTabIndex.second = index
    },
    getList () {
      if (this.finished) return

      this.loading = true
      getListByType({
        pageNo: this.pageNo,
        type: this.currentTab.id,
        secondType: this.currentTabIndex.first === 1 ? this.currentChildTab.id : ''
      })
        .then((res) => {
          if (res.success) {
            const { result } = res
            this.list = [
              ...(this.pageNo === 1 && this.currentTabIndex.first === 0
                ? wxList
                : []),
              ...this.list,
              ...(result.records || []).map((item) => {
                return {
                  ...item,
                  year: item.createTime.slice(0, 4)
                }
              })
            ]
            if (this.isGroup) {
              if (this.pageNo === 1 && this.groupList.length) {
                this.groupActives = [this.groupList[0].year]
              }
            } else {
              this.groupActives = []
            }
            this.pageNo++
            this.finished = result.pages === 0 || result.current === result.pages
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    refresh () {
      this.pageNo = 1
      this.finished = false
      this.list = []
      this.getList()
    },
    toDetail (data) {
      if (data.isWx) {
        wxInfo({ appName: data.id }).then((res) => {
          this.openLink = res.result.openlink
          location.href = this.openLink
        })
      } else {
        window.location.href = data.externalLink
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
